module.exports = __webpack_public_path__ + "img/pause.cfd63065.svg";